import React from 'react';
import { Container } from 'reactstrap';
import { DashboardPageHeader, DeptModulesGrid } from '../../Components/Common/DashboardKit';

/**
 * Quality module landing page.
 *
 * Owner (2026-10-05/06): the department pages show MODULES, one card per module, the
 * same cards as the Workflows catalog (DeptLandingSections); a card shows only when the
 * person may open it. The Reports & KPI card opens the KPI hub on this department's tab.
 * No "coming soon" note. The route is gated by dept.quality in allRoutes.js.
 */
const MODULES = ["di", "app-mafia", "cr", "dms", "tasks", "epo", "kpi"];

const Quality = () => {
    document.title = "SSW Technologies Dashboard";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <DashboardPageHeader
                        icon="ri-shield-check-line"
                        eyebrow="Quality"
                        title="Quality"
                        subtitle="Inspection, non-conformance, and audits"
                        tone="teal"
                        breadcrumb={[
                            { label: "Dashboards", to: "/" },
                            { label: "Quality" },
                        ]}
                    />

                    <DeptModulesGrid ids={MODULES} dept="quality" title="Quality modules" icon="ri-microscope-line" />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Quality;
